import React from 'react';
import DashboardHome from '../components/DashboardHome';

const Dashboard: React.FC = () => (
  <div style={{ marginTop: 16 }}>
    <DashboardHome />
  </div>
);

export default Dashboard;
